import { ILevelDomainData } from "src/app/infrastructure/models/level-domain-data";
import { ILevelDomainListData, levelDomainListData } from "src/app/infrastructure/models/level-domain-list-data";
import { IRoleListDto, roleListDto } from "src/assets/common/models/role-list-dto.g";
import { roleTypeLabel_get } from './role-type';

export const roleListData = {
    ... levelDomainListData,
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    // Zelfde sleutel als roleData, zodat lijst-templates het type uit beide kunnen lezen.
    domainAssignable: 'domainAssignable',
    // Afgeleid (role-type.ts): het type als tekst — zoek-/sorteerveld (filterpaneel: 'Type').
    type: 'type',
    deleted: 'deleted',    
    inactive: 'inactive',
} as const

export type TRoleListData = (typeof roleListData)[keyof typeof roleListData];

export interface IRoleListData extends ILevelDomainListData{
    [roleListData.requestedDomainUser_guid]: string;
    [roleListData.domain_guid]: string;
    
    [roleListData.guid]: string;
    [roleListData.nr]: number | null;
    [roleListData.name]: string | null;
    [roleListData.domainAssignable]: boolean;
    [roleListData.type]: string;
    [roleListData.deleted]: boolean;
    [roleListData.inactive]: boolean;
}

export class RoleListData
    implements IRoleListData, ILevelDomainData
{
    [roleListData.requestedDomainUser_guid]!: string;
    [roleListData.domain_guid]!: string;
    
    [roleListData.guid]!: string;
    [roleListData.nr]: number | null = null;
    [roleListData.name]: string | null = null;
    [roleListData.domainAssignable]: boolean = false;
    [roleListData.type]!: string;
    [roleListData.deleted]: boolean = false;
    [roleListData.inactive]: boolean = false;

    private constructor(modelListDto: IRoleListDto) {
        if (!modelListDto) return;

        this[roleListData.requestedDomainUser_guid] = modelListDto[roleListDto.requestedDomainUser_Guid]!;
        this[roleListData.domain_guid] = modelListDto[roleListDto.domain_Guid]!;

        this[roleListData.guid] = modelListDto[roleListDto.guid]!;
        this[roleListData.nr] = modelListDto[roleListDto.nr];
        this[roleListData.name] = modelListDto[roleListDto.name];
        this[roleListData.domainAssignable] = !!modelListDto[roleListDto.domainAssignable];
        this[roleListData.type] = roleTypeLabel_get(this);
        this[roleListData.deleted] = modelListDto[roleListDto.deleted] ?? false;
        this[roleListData.inactive] = modelListDto[roleListDto.inactive] ?? false;
    }

    static create(modelListDto?: IRoleListDto | null): IRoleListData | null {
        return modelListDto ? new RoleListData(modelListDto) : null;
    }
}
